import axios from "@/utils/axiosHelper";

// 初始化数据(含授权)
export const onGetInitDataAPI = params => {
  return axios(
    { url: "/snail/three/reports/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 彩蛋奖励
export const easterEggRewardAPI = params => {
  return axios(
    { url: "/snail/three/reports/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 抽奖
export const lotteryAPI = params => {
  return axios(
    { url: "/snail/three/reports/lottery", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 抽奖记录
export const lotteryDetailAPI = params => {
  return axios(
    { url: "/snail/three/reports/list", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 填写收货地址
export const addressAPI = params => {
  return axios(
    { url: "/snail/three/reports/address", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 登出
export const LogoutAPI = data => {
  return axios({ url: "/game/my/disable", method: "POST", data });
};



// WEBPACK FOOTER //
// ./src/pages/snail/triennial/api.js